import { useEffect } from 'react';

const MatomoTrackMediaAnalytics = () => {
  useEffect(() => {
    if (window?.Matomo?.MediaAnalytics) {
      var MA = window.Matomo.MediaAnalytics;

      var MediaflowPlayer = function (element, config) {
        if (!element) {
          return;
        }

        if (!window.addEventListener) {
          return;
        }

        if (element.playerInstance) {
          return;
        }

        element.playerInstance = true;

        var mediaResource = MA.element.getMediaResource(element, null);

        var playerInstance = new MA.MediaTracker(
          'mediaflow',
          config,
          mediaResource
        );

        playerInstance.setWidth(element.clientWidth);
        playerInstance.setHeight(element.clientHeight);
        playerInstance.setFullscreen(MA.element.isFullscreen(element));

        window.addEventListener(
          'resize',
          function () {
            playerInstance.setWidth(element.clientWidth);
            playerInstance.setHeight(element.clientHeight);
            playerInstance.setFullscreen(MA.element.isFullscreen(element));
          },
          false
        );

        var title = MA.element.getMediaTitle(element);

        if (title) {
          playerInstance.setMediaTitle(title);
        }

        playerInstance.trackUpdate();

        var messageHandler = function (event) {
          if (
            !/play\.mediaflowpro\.com/.test(event.origin) &&
            !/play\.mediaflow\.com/.test(event.origin)
          ) {
            return false;
          }

          if (!event || !event.data) {
            return;
          }

          if (
            element.contentWindow &&
            event.source &&
            element.contentWindow !== event.source
          ) {
            return;
          }

          var data = event.data;

          if ('string' === typeof data) {
            data = JSON.parse(event.data);
          }

          if ('event' in data && data.event === 'ready') {
            if (origin === '*') {
              origin = event.origin;
            }

            if (!element.isMediaflowReady) {
              element.isMediaflowReady = true;
              postMessage('addEventListener', 'play');
              postMessage('addEventListener', 'pause');
              postMessage('addEventListener', 'ended');
              postMessage('addEventListener', 'timeupdate');
            }

            return;
          }

          if ('event' in data) {
            var eventName = data.event;
            switch (eventName) {
              case 'play':
                playerInstance.play();
                break;
              case 'timeupdate':
                playerInstance.setMediaProgressInSeconds(data.value);
                playerInstance.update();
                break;
              case 'pause':
                playerInstance.pause();
                break;
              case 'ended':
                playerInstance.finish();
                break;
            }
          }
        };

        window.addEventListener('message', messageHandler, true);

        var origin = '*';

        function postMessage(method, value) {
          var message = { method: method };
          if (value !== undefined) {
            message.value = value;
          }

          if (element && element.contentWindow) {
            if (navigator && navigator.userAgent) {
              var ieVersion = parseFloat(
                navigator.userAgent
                  .toLowerCase()
                  .replace(/^.*msie (\d+).*$/, '$1')
              );
              if (ieVersion >= 8 && ieVersion < 10) {
                message = JSON.stringify(message);
              }
            }
            element.contentWindow.postMessage(message, origin);
          }
        }
      };

      MediaflowPlayer.scanForMedia = function (container) {
        if (!window.addEventListener) {
          return;
        }
        var iframes = container.getElementsByTagName('iframe');

        for (var i = 0; i < iframes.length; i++) {
          if (MA.element.isMediaIgnored(iframes[i])) {
            continue;
          }

          var src = MA.element.getAttribute(iframes[i], 'src');

          if (
            src &&
            (src.indexOf('play.mediaflowpro.com') > 0 ||
              src.indexOf('play.mediaflow.com') > 0)
          ) {
            new MediaflowPlayer(iframes[i], MA.mediaType.VIDEO);
          }
        }
        iframes = null;
      };

      MA.addPlayer('MediaflowPlayer', MediaflowPlayer);
    }
  }, []);

  return null;
};

export default MatomoTrackMediaAnalytics;
